import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/runner';
import { listNavigator } from 'sagas/common';
import filters from 'filters/runner';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Runner', actions, selectors, filters } );
}
